module.exports = __webpack_public_path__ + "media/img/Fill-1-green-e7bf3364.svg";